import { gql } from "@apollo/client";

export const getRCAComplianceByMill = gql`
    query getRCAComplianceByMill(
        $args: get_rca_compliance_totals_by_mill_args!
        $where: rca_compliance_totals_by_mill_bool_exp
    ) {
        rca_compliance_by_mill: get_rca_compliance_totals_by_mill(where: $where, args: $args) {
            mill_id
            completed_on_time
            pending
            completed_late
            pending_late
            total_rcas_by_period
        }
    }
`;

export const getRCAComplianceByResponsible = gql`
    query getRCAComplianceByResponsible(
        $args: get_rca_compliance_totals_by_responsible_args!
        $where: rca_compliance_totals_by_responsible_bool_exp
    ) {
        rca_compliance_totals_by_responsible: get_rca_compliance_totals_by_responsible(where: $where, args: $args) {
            mill_id
            user {
                user_id
                first_name
                last_name
                media {
                    media_url
                }
            }
            completed_on_time
            pending
            completed_late
            pending_late
            total_rcas_by_responsible
        }
    }
`;

export const getActionPlanComplianceByMill = gql`
    query getActionPlanComplianceByMill(
        $args: get_action_plan_compliance_totals_by_mill_args!
        $where: action_plan_compliance_totals_by_mill_bool_exp
    ) {
        action_plan_compliance_by_mill: get_action_plan_compliance_totals_by_mill(where: $where, args: $args) {
            mill_id
            completed_on_time
            pending
            completed_late
            pending_late
            total_action_plans_by_period
        }
    }
`;

export const getAPComplianceByResponse = gql`
    query getAPComplianceByResponsible(
        $args: get_action_plan_compliance_totals_by_responsible_args!
        $where: action_plan_compliance_totals_by_responsible_bool_exp
    ) {
        action_plan_compliance_totals_by_responsible: get_action_plan_compliance_totals_by_responsible(
            where: $where
            args: $args
        ) {
            mill_id
            user {
                user_id
                first_name
                last_name
                media {
                    media_url
                }
            }
            completed_on_time
            pending
            completed_late
            pending_late
            total_action_plans_by_responsible
        }
    }
`;

export const getAvgActionPlansPerUserResponse = gql`
    query getAvgActionPlansPerUser($args: get_avg_action_plans_per_user_by_date_args!) {
        avg_action_plans_per_user_by_date: get_avg_action_plans_per_user_by_date(args: $args) {
            user_id
            first_name
            last_name
            media_url
            average_action_plans_per_rca
            rca_without_action_plans
            rca_without_ap_list
        }
    }
`;

export const getRcaMethodologyUsedByUserResponse = gql`
    query getRcaMethodologyUsedByUser($args: get_rca_methodology_used_by_user_args!) {
        rca_methodology_used_by_user: get_rca_methodology_used_by_user(args: $args) {
            user_id
            first_name
            last_name
            media_url
            fishbone_percentage
            five_why_percentage
            none_percentage
            none_methodology_rca_list
        }
    }
`;

export const getRCADisplayNumbers = gql`
    query getRCADisplayNumbers($rca_ids: [Int!]!) {
        rca(where: { rca_id: { _in: $rca_ids } }) {
            rca_id
            display_number
        }
    }
`;
